import { Notification } from 'bloomer'
import { useTranslation } from 'react-i18next'

export default function () {
  const { t } = useTranslation()
  return (
    <Notification isColor="warning">
      { t('errorPages.notFound') }
    </Notification>
  )
}
